function initPulseCardProduct() {
    if (document.querySelector('.articles-detailed__slide-wrapper') != null) {
        let wrapper = document.querySelector('.articles-detailed__slide-wrapper')
        let doors = wrapper.querySelectorAll('.Card-product')
        let interval
        doors.forEach(el => el.classList.add('Card-product--scaledown'))

        const pulse = () => {
            interval = setInterval(() => {
                doors.forEach(el => {
                    el.classList.toggle('Card-product--scaledown')
                    el.classList.toggle('Card-product--scaleup')
                })
            }, 1000)

        }
        pulse()

        wrapper.onmouseover = wrapper.onmouseout = handler

        function handler(e) {
            if (e.type === 'mouseover') {
                clearInterval(interval)
                doors.forEach(el => {
                    el.classList.add('Card-product--scaledown')
                    el.classList.remove('Card-product--scaleup')
                })
            }
            if (e.type === 'mouseout') {
                pulse()
            }
        }
    }
}